import axios from 'axios';

export class ProductService {
    getProductsSmall() {
        return axios.get('assets/demo/data/products-small.json').then((res) => res.data.data);
    }

    getProducts() {
        return axios.get('assets/demo/data/products.json').then((res) => res.data.data);
    }

    getProductsWithOrdersSmall() {
        return axios.get('assets/demo/data/products-orders-small.json').then((res) => res.data.data);
    }

    async getReporteProductos(baseUrl) {
        const response = await fetch(`${baseUrl}reporteProductos`, {
            method: "GET",
            credentials: "include",
        });

        if (!response.ok) {
            let detalle = `Error al exportar reporte de productos (${response.status})`;
            try {
                const err = await response.json();
                if (err && err.detalle) {
                    detalle = err.detalle;
                }
            } catch (e) {
                // La respuesta de error no es JSON
            }
            throw new Error(detalle);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "reporte_productos.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }

    // ==================== EMPRESAS ====================

    async getAllEmpresas(baseUrl) {
        const response = await fetch(`${baseUrl}/getAllEmpresas`);
        if (!response.ok) {
            throw new Error(`Error al obtener las empresas (${response.status})`);
        }
        return await response.json();
    }

    async getEmpresaById(baseUrl, id) {
        const response = await fetch(`${baseUrl}getEmpresaById?id=${id}`, {
            method: "GET",
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`Error al obtener empresa para medidores: ${response.status}`);
        }
        return await response.json();
    }

    async getEmpresaByNombre(baseUrl, empresa) {
        const response = await fetch(`${baseUrl}getEmpresaByNombre?empresa=${empresa}`);
        if (!response.ok) {
            throw new Error(`Error al obtener la empresa (${response.status})`);
        }
        return await response.json();
    }

    // ==================== PRODUCTOS ====================

    async getProductosByEmpresa(baseUrl, empresa) {
        const response = await fetch(`${baseUrl}getProductosByEmpresa?empresa=${empresa}`);
        if (!response.ok) {
            throw new Error(`Error al obtener productos (${response.status})`);
        }
        const data = await response.json();
        return data.productos;
    }

    async getTiposProductoByEmpresa(baseUrl, empresa) {
        const response = await fetch(`${baseUrl}getTiposProductoByEmpresa?empresa=${empresa}`);
        if (!response.ok) {
            throw new Error(`Error al obtener tipos de producto (${response.status})`);
        }
        const data = await response.json();
        return data.tiposProductos;
    }

    async getProductosByTipo(baseUrl, idTipo) {
        const response = await fetch(`${baseUrl}getProductosByTipo?idTipo=${idTipo}`);
        if (!response.ok) {
            throw new Error(`Error al obtener productos por tipo (${response.status})`);
        }
        return await response.json();
    }

    async createProducto(baseUrl, { empresa, descripcion, metraje, idTipoProducto, idUsuario }, headers) {
        const queryParams = new URLSearchParams({
            empresa,
            descripcion,
            metraje: metraje.toString(),
            idTipoProducto: idTipoProducto.toString(),
            idUsuario: idUsuario
        });

        const response = await fetch(`${baseUrl}createProducto?${queryParams.toString()}`, {
            method: "POST",
            headers,
        });

        const data = await response.json();

        // Defensa ante HTTP 200 con error logico: el backend puede responder
        // { respuesta: false, mensaje } incluso con status OK
        if (!response.ok || data.respuesta === false) {
            throw new Error(data.mensaje || "Error al crear producto");
        }

        return data;
    }

    async updateProducto(baseUrl, producto, headers) {
        const response = await fetch(`${baseUrl}updateProducto`, {
            method: "PUT",
            headers,
            body: JSON.stringify(producto),
        });
        if (!response.ok) {
            throw new Error("Error saving the product");
        }
        return await response.json();
    }

    // ==================== FICHA TÉCNICA ====================

    async getProductoFicha(baseUrl, idProducto) {
        const response = await fetch(`${baseUrl}getProductoFicha?idProducto=${idProducto}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Accept: "application/json; charset=utf-8",
            },
        });
        if (!response.ok) {
            throw new Error(`Error al obtener la ficha del producto (${response.status})`);
        }
        return await response.json();
    }

    async createProductoFicha(baseUrl, { idProducto, perfil, ficha }) {
        const response = await fetch(`${baseUrl}/createProductoFicha`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify({ idProducto, perfil, ficha }),
        });
        if (!response.ok) {
            throw new Error("Error al crear la ficha técnica");
        }
        return true;
    }

    async updateProductoFicha(baseUrl, { idProducto, perfil, ficha }) {
        const response = await fetch(`${baseUrl}updateProductoFicha`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Accept: "application/json; charset=UTF-8",
            },
            body: JSON.stringify({ idProducto, perfil, ficha }),
        });
        if (!response.ok) {
            throw new Error("Error al actualizar la ficha del producto");
        }
        return true;
    }

    // ==================== PRODUCTOS ADYACENTES / UNIONES ====================

    async createProductoAdyacente(baseUrl, { idProducto, productos }, headers) {
        const queryParams = new URLSearchParams({
            idProducto,
            productos: JSON.stringify(productos)
        });

        const response = await fetch(`${baseUrl}createProductoAdyacente?${queryParams.toString()}`, {
            method: "POST",
            headers,
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.mensaje || "Error al crear producto adyacente");
        }

        return data;
    }

    async updateProductoAdyacente(baseUrl, { idProducto, productos }, headers) {
        const queryParams = new URLSearchParams({
            idProducto,
            productos: JSON.stringify(productos)
        });

        const response = await fetch(`${baseUrl}updateProductoAdyacente?${queryParams.toString()}`, {
            method: "POST",
            headers,
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.mensaje || "Error al actualizar producto adyacente");
        }

        return data;
    }

    async desactivarProductoAdyacente(baseUrl, idProducto, headers) {
        const response = await fetch(`${baseUrl}desactivarProductoAdyacente?idProducto=${idProducto}`, {
            method: "POST",
            headers,
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.mensaje || "Error al actualizar producto adyacente");
        }

        return data;
    }

    async deleteUnionProducto(baseUrl, idProducto) {
        const body = new URLSearchParams({ idProducto });

        const response = await fetch(`${baseUrl}deleteUnionProducto`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            },
            body,
            credentials: "include",
        });

        if (!response.ok) {
            const errText = await response.text();
            throw new Error(errText || "Error al desactivar la union de productos");
        }

        return true;
    }

    async createUnionProducto(baseUrl, { empresa, descripcion, idTipo, productos, idUsuario }) {
        const queryParams = new URLSearchParams({
            empresa,
            descripcion,
            idTipo,
            productos: JSON.stringify(productos),
            idUsuario
        });

        const response = await fetch(`${baseUrl}createUnionProducto?${queryParams.toString()}`, {
            method: "POST",
            headers: { "Content-Type": "application/json;charset=UTF-8" },
        });

        const data = await response.json();

        // Defensa ante HTTP 200 con error logico: el backend puede responder
        // { respuesta: false, mensaje } incluso con status OK
        if (!response.ok || data.respuesta === false) {
            throw new Error(data.mensaje || "Error al crear producto");
        }

        return data;
    }

    async verificarProductoAsignado(baseUrl, idProducto) {
        const response = await fetch(`${baseUrl}verificarProductoAsignado?idProducto=${idProducto}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
            throw new Error("Error al verificar disponibilidad del producto");
        }

        return await response.json();
    }

    // ==================== TIPOS DE PRODUCTO / COMBOS ====================

    async createTipoProducto(baseUrl, { empresa, descripcion, unidad, idUsuario, tarifa }) {
        const queryParams = new URLSearchParams({
            empresa,
            descripcion,
            unidad,
            idUsuario,
            tarifa,
        });

        const response = await fetch(`${baseUrl}createTipoProducto?${queryParams.toString()}`, {
            method: "POST",
            headers: { "Content-Type": "application/json;charset=UTF-8" },
        });

        const data = await response.json();

        if (!response.ok || data.respuesta === false) {
            throw new Error(data.mensaje || "Error creating TipoProducto");
        }

        return data;
    }

    async verificarTipoCombo(baseUrl, descripcion) {
        const response = await fetch(
            `${baseUrl}verificarTipoCombo?descripcion=${encodeURIComponent(descripcion)}`,
            { method: "GET" }
        );
        if (!response.ok) {
            throw new Error(`Error al verificar tipo de combo (${response.status})`);
        }
        return await response.json();
    }

    // ==================== SUBPRODUCTOS ====================

    async getSubproductosEntidad(baseUrl, idEmpresa) {
        const query = idEmpresa != null ? `?idEmpresa=${idEmpresa}` : "";
        const response = await fetch(`${baseUrl}getSubproductosEntidad${query}`);
        if (!response.ok) {
            throw new Error(`Error al obtener subproductos (${response.status})`);
        }
        return await response.json();
    }

    async insertProductoSubproductoEntidad(baseUrl, { idEmpresa, idProducto, idSubproducto }) {
        const response = await fetch(
            `${baseUrl}insertProductoSubproductoEntidad?idEmpresa=${idEmpresa}&idProducto=${idProducto}&idSubproducto=${idSubproducto}`,
            { method: "POST", redirect: "follow" }
        );
        const data = await response.json().catch(() => null);
        if (!response.ok) {
            throw new Error((data && data.mensaje) || `Error al insertar subproducto (${response.status})`);
        }
        return true;
    }

    async deleteProductoSubproducto(baseUrl, idProductoSubproducto) {
        const response = await fetch(
            `${baseUrl}deleteProductoSubproducto?idProductoSubproducto=${idProductoSubproducto}`,
            { method: "PUT" }
        );
        if (!response.ok) {
            const txt = await response.text();
            throw new Error(txt || `Error al desasociar subproducto (HTTP ${response.status})`);
        }
        return true;
    }

async deleteProductoSubproductoEntidad(baseUrl, { idProducto, idSubproducto }) {
        const response = await fetch(
            `${baseUrl}deleteProductoSubproductoEntidad?idProducto=${idProducto}&idSubproducto=${idSubproducto}`,
            { method: "PUT", redirect: "follow" }
        );
        if (!response.ok) {
            const txt = await response.text();
            let mensaje = txt;
            try {
                const j = JSON.parse(txt);
                if (j && j.mensaje) mensaje = j.mensaje;
            } catch (e) {
                // cuerpo no JSON: se usa el texto como mensaje
            }
            throw new Error(mensaje || `Error al desasociar subproducto (${response.status})`);
        }
        return true;
    }

    // ==================== MEDIDORES ====================

    async checkServicioMedidores(urlMedidores) {
        let response;
        try {
            response = await fetch(`${urlMedidores}tipo/buscar`, {
                method: "GET",
                credentials: "include",
            });
        } catch (error) {
            throw new Error("No fue posible validar el servicio de medidores");
        }

        if (!response.ok) {
            throw new Error(`Servicio de medidores no disponible (${response.status})`);
        }

        const contentType = response.headers.get("content-type") || "";
        if (!contentType.toLowerCase().includes("application/json")) {
            throw new Error("Servicio de medidores no disponible (respuesta inválida)");
        }

        const data = await response.json();
        const servicioActivo = data?.respuesta === true && Array.isArray(data?.tipos);

        if (!servicioActivo) {
            throw new Error("Servicio de medidores no disponible (sin datos de tipos)");
        }

        return true;
    }

    async buscarTiposRemarcador(urlMedidores) {
        const response = await fetch(`${urlMedidores}tipo/buscar`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();

        if (!response.ok || !data.respuesta) {
            throw new Error(data.mensaje || "No fue posible cargar los tipos de remarcador");
        }

        return Array.isArray(data.tipos) ? data.tipos : [];
    }

    async buscarProveedores(urlMedidores) {
        const response = await fetch(`${urlMedidores}proveedor/buscar`, {
            method: "GET",
            credentials: "include",
        });
        const data = await response.json();

        if (!response.ok || !data.respuesta) {
            throw new Error(data.mensaje || "No fue posible cargar los proveedores");
        }

        return Array.isArray(data.proveedores) ? data.proveedores : [];
    }

    async insertarDomicilio(urlMedidores, body) {
        const response = await fetch(`${urlMedidores}/domicilio/insertarDomicilio`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
            },
            body: JSON.stringify(body),
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error(
                `Error al insertar domicilio/remarcadores en medidores: ${response.status}`
            );
        }

        return true;
    }
}
